<menu>
    <div class="container">
        <nav>
            <ul>
                <li><a routerLink="/" routerLinkActive="active" class="logo-header" [routerLinkActiveOptions]="{exact:
                    true}">wb.tech</a></li>
                    <li *ngIf="auth.isLoggedIn"><a routerLink="/mycourses" routerLinkActive="active">Мои курсы</a></li>
                <li><a routerLink="/courses" routerLinkActive="active">Все курсы</a></li>
                <ng-container *ngIf="auth.isLoggedIn">
                    <li *ngIf="auth.roleMatch(['superadmin', 'creator', 'admin'])">
                        <a routerLink="/admin" routerLinkActive="active">Admin panel</a>
                    </li>
                </ng-container>
                <div *ngIf="auth.isLoggedIn; then profile else signIn"></div>
                <ng-template #profile>
                    <li class="profile">
                        <a routerLink="/profile" routerLinkActive="active" >
                            <i class="fas fa-user-alt"></i>
                            Профиль
                        </a>
                    </li>
                </ng-template>
                <ng-template #signIn>
                    <li class="sign-in"><button mat-raised-button  (click)="openLogin()">Войти</button></li>
                </ng-template>
            </ul>
        </nav>
    </div>
</menu>
<breadcrumb #parent>
    <ng-container  *ngIf="parent.breadcrumbs.length > 1; else noCrumbs" >
        <div class="container">
            <ol class="breadcrumb">
            <ng-template ngFor let-route [ngForOf]="parent.breadcrumbs">
                <li *ngIf="!route.terminal" class="breadcrumb-item">
                <a [routerLink]="[route.url]">{{ route.displayName }}</a>
                <span class="separator">/</span>
                </li>
                <li *ngIf="route.terminal" class="breadcrumb-item active" aria-current="page">{{ route.displayName }}</li>
            </ng-template>
            </ol>
        </div>
    </ng-container>
    <ng-template #noCrumbs>
        <div><!-- no crumbs --></div>
    </ng-template>
</breadcrumb> 